import React from 'react';
import OfferNotification from '../../Features/OfferConfiguration/Components/OfferNotification/OfferNotification';
import RenewalNotification from '../../Features/LoanApp/Cards/RenewalNotification';
import DelayedFundingNotification from '../../Features/LoanApp/Cards/DelayedFundingNotification';
import { useApplication } from 'merchant-api/unified';
import { useOffers } from 'merchant-api/offer';
import { delayedFundingDate } from 'merchant-api/derived';

export type NotificationGateViewProps = {
  showDelayedFunding?: Boolean;
  showOfferNotification: Boolean;
  hideRenewal?: boolean;
  delayedFundingNode?: React.ReactNode;
  offerNode?: React.ReactNode;
  renewalNode?: React.ReactNode;
};

export const NotificationGateView = ({ showDelayedFunding, showOfferNotification, hideRenewal, delayedFundingNode,
                                       offerNode = <OfferNotification />, renewalNode = <RenewalNotification /> }: NotificationGateViewProps) => {
  // Delayed funding replaces the renewal card: don't pitch a renewal to a merchant waiting on funds.
  if (showDelayedFunding) return <>{delayedFundingNode}</>;
  if (showOfferNotification) return <>{offerNode}</>;
  return <>{hideRenewal ? null : renewalNode}</>;
};

export const NotificationGate = () => {
  // strictStatus: the unfiltered fallback never returns FUNDING, so falling back is wasted.
  const { applicationData: fundingApp, isLoadingApplication: fundingLoading } = useApplication(['FUNDING'], true);
  const fundingDate = delayedFundingDate(fundingApp);
  const { applicationData, isPAR } = useApplication(['APPROVED']);
  const { product, isPartnerChannel, selectedOffer } = useOffers();

  // Wait so the renewal card can't flash (and be clicked) before the FUNDING lookup resolves.
  if (fundingLoading) return null;

  const showOfferForISO = !isPartnerChannel || !!selectedOffer || isPAR;
  const showOfferNotification = applicationData?.status === 'APPROVED' && !!product && showOfferForISO;

  return (
    <NotificationGateView
      showDelayedFunding={!!fundingDate}
      showOfferNotification={showOfferNotification}
      // Past the banner window there's no current app, so the renewal CTA would create a duplicate.
      // An in-progress app (applicationData via the unfiltered fallback) keeps its card.
      hideRenewal={!!fundingApp && !applicationData}
      delayedFundingNode={fundingDate && <DelayedFundingNotification fundingDate={fundingDate} />}
    />
  );
};

export default NotificationGate;
